

















import Vue from 'vue'
import InputSection from '@/components/inputSection.vue'
import DownloadButton from '@/components/downloadButton.vue'
import DropdownMenu from '@/components/dropdownMenu.vue'

import { mapGetters } from 'vuex'
import { navigators } from '../data'
import { GETTERS_ACTIONS, MUTATIONS_ACTIONS } from '@/types'

export default Vue.extend({
  name: 'BaseSidebar',
  components: {
    InputSection,
    DownloadButton,
    DropdownMenu
  },
  data () {
    return {
      navigators
    }
  },
  computed: {
    ...mapGetters([GETTERS_ACTIONS.GET_TAB_RESOURCE])
  },
  methods: {
    setSidebar (val: string) {
      this.$store.commit(MUTATIONS_ACTIONS.TOGGLE_TAB_SELECTOR, val)
    }
  }
})
